import { render, staticRenderFns } from "./HotDestinationsGrid.vue?vue&type=template&id=22c95e48&scoped=true"
import script from "./HotDestinationsGrid.vue?vue&type=script&lang=js"
export * from "./HotDestinationsGrid.vue?vue&type=script&lang=js"
import style0 from "./HotDestinationsGrid.vue?vue&type=style&index=0&id=22c95e48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c95e48",
  null
  
)

export default component.exports